export enum Role {
    ADMIN
  }
